"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var State = (function () {
    function State(config) {
        this.config = config;
        this.aprilCruises = [];
        this.aprilCruiseIds = [];
        this.pricePlanCodes = [];
        this.teaserOffers = [
            {
                amenities: [
                    {
                        amount: 0,
                        description: '',
                        id: '',
                        type: '',
                    },
                ],
                bookableUntil: '',
                cabinCategoryOffer: {
                    code: '',
                    image: '',
                    name: '',
                },
                cheapestCruiseIndex: 0,
                cheapestPrice: 0,
                cruises: [],
                duration: 0,
                endPort: '',
                itineraryId: '',
                portImage: {
                    alt: {},
                    file: '',
                    keywords: [],
                    uid: '',
                },
                priceInfo: {
                    amount: 0,
                    priceModel: '',
                    surcharges: [],
                },
                regionIds: [],
                routeName: '',
                startPort: '',
            },
        ];
        this.teaserOffersReduced = [];
        this.carolCampaign = {
            campaignEnd: '',
            campaignStart: '',
            campaignTeaserPricesStart: '',
            contentSections: [],
            contentSectionsHeadline: '',
            createdAt: '',
            description: '',
            descriptionHtml: '',
            headerImage: {
                alt: {},
                file: '',
                keywords: [],
                uid: '',
            },
            headline: '',
            id: '',
            specialOffers: [],
            subHeadline: '',
            tariffInformationDescription: '',
            tariffInformationDescriptionHtml: '',
            tariffInformationHeadline: '',
            teaserImage: {
                alt: {},
                file: '',
                keywords: [],
                uid: '',
            },
            updatedAt: '',
        };
        this.timingStates = {
            ended: false,
            priceCommunicationStarted: false,
            started: false,
        };
        this.timeStamp = '';
        this.filter = {
            region: 'NONE',
            timeFrom: '',
            timeTo: '',
            travelDuration: 9999,
        };
        this.availableDurations = [
            {
                from: 1,
                id: 0,
                name: 'Reisedauer',
                shortName: 'Dauer',
                to: 9999,
            },
            {
                from: 1,
                id: 1,
                name: '1-5 Tage',
                shortName: '1-5 Tage',
                to: 5,
            },
            {
                from: 6,
                id: 6,
                name: '6-9 Tage',
                shortName: '6-9 Tage',
                to: 9,
            },
            {
                from: 10,
                id: 10,
                name: '10-13 Tage',
                shortName: '10-13 Tage',
                to: 13,
            },
            {
                from: 14,
                id: 14,
                name: '14-21 Tage',
                shortName: '14-21 Tage',
                to: 21,
            },
            {
                from: 22,
                id: 22,
                name: 'ab 22 Tage',
                shortName: 'ab 22 Tage',
                to: 99999,
            },
        ];
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map